import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import SignIn from "./page/SignIn";
import SignUp from "./page/SignUp";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-quill/dist/quill.snow.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./style/home.css";
import SideBar from "./component/SideBar";
import { useState } from "react";
import Step4 from "./component/Step4";
import Step5 from "./component/Step5";
import WalkThrough from "./page/WalkThrough";
import Admin from "./page/Admin";
import RecordingDetails from "./page/RecordingDetails";
import ForgotPassword from "./page/ForgotPassword";
import ChangePassword from "./page/ChangePassword";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./component/ProtectedRoute";
import AddUser from "./page/AddUser";
import AddAppointment from "./page/AddAppointment";
import PatientReview from "./page/PatientReview";
import WrapUpPage from "./page/WrapUpPage";
import OverviewNewPage from "./page/OverviewNewPage";
import NextPatientSidebar from "./component/NextPatientSidebar";
import SlotsPage from "./page/SlotsPage";
import AdminPage from "./page/AdminPage";
import RecordPage from "./page/Record";

function App() {
  const [privacyMode, setPrivacyMode] = useState(false);
  const [activeStep, setStep] = useState(1);
  const [page, setPage] = useState("START");

  const setActiveStep = (step) => {
    setStep(step);
  };

  const [formData, setFormData] = useState({
    client_name: "",
    client_number: "",
  });

  console.log("formData", formData);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <SideBar
                setPrivacyMode={setPrivacyMode}
                page={page}
                setPage={setPage}
              />
            }
          >
            {/* <Route
              path="home"
              element={
                <ProtectedRoute>
                  <MainHome
                    privacyMode={privacyMode}
                    setFormData={setFormData}
                    setActiveStep={setActiveStep}
                  />
                </ProtectedRoute>
              }
            />

            <Route
              path="tasks"
              element={
                <ProtectedRoute>
                  <Tasks />
                </ProtectedRoute>
              }
            /> */}

            <Route path="/home/nextpatient" element={<NextPatientSidebar />}>
              <Route path="overview" element={<OverviewNewPage />} />
              <Route path="slots" element={<SlotsPage />} />
              <Route path="admin" element={<AdminPage />} />
            </Route>

            <Route
              path="home/walkthrough"
              element={
                <ProtectedRoute>
                  <WalkThrough activeStep={activeStep} />
                </ProtectedRoute>
              }
            >
              <Route
                path="record"
                element={
                  <RecordPage setActiveStep={setActiveStep} setPage={setPage} />
                }
              />

              <Route
                path="review-note"
                element={<PatientReview setActiveStep={setActiveStep} />}
              />

              <Route
                path="wrap-up"
                element={<WrapUpPage setActiveStep={setActiveStep} />}
              />

              <Route
                path="review"
                element={
                  <Step4 setActiveStep={setActiveStep} setPage={setPage} />
                }
              />

              {/* <Route
                path="wrap-up"
                element={
                  <Step5 setActiveStep={setActiveStep} setPage={setPage} />
                }
              /> */}
            </Route>

            <Route
              path="admin"
              element={
                <ProtectedRoute adminOnly={true}>
                  <Admin privacyMode={privacyMode} />
                </ProtectedRoute>
              }
            />

            <Route
              path="add-user"
              element={
                <ProtectedRoute adminOnly={true}>
                  <AddUser />
                </ProtectedRoute>
              }
            />
            <Route
              path="add-appointment"
              element={
                <ProtectedRoute adminOnly={true}>
                  <AddAppointment />
                </ProtectedRoute>
              }
            />
            <Route
              path="recording-details"
              element={
                <ProtectedRoute>
                  <RecordingDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="change-password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />

            <Route
              path=""
              element={<Navigate to="/home/walkthrough/record" />}
            />
          </Route>
          <Route path="/sign-in" element={<SignIn />} />
          {/* <Route path="/sign-up" element={<SignUp />} /> */}
          <Route path="*" element={<Navigate to="/sign-in" />} />
          {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
